import React from 'react'
import SidebarHeader from '../Form/BackArrow/SidebarHeader'

const DailyUpdateCommentCard = ({
    selectedDealCommentsList,
    handleDailyUpdateCommentBack,
}) => {
  return (
    <>

      
<SidebarHeader onClick={handleDailyUpdateCommentBack} title={"Daily Update & Comments"}/>

<div className="mt-1">
  {selectedDealCommentsList.length > 0 ? (
    selectedDealCommentsList.reverse().map((comments, index) => (
      <div
        key={index}
        className="w-full p-5 mt-5 rounded-lg shadow-md bg-white border border-gray-300"
      >
        <div className="text-xl text-emerald-600 font-bold mb-3">
          Comment
        </div>

        <div className="flex mb-2 break-words">
          <div className="w-full font-semibold ">
            {comments?.comment}
          </div>
        </div>

        <div className="flex mb-2 gap-2">
          <div className="font-semibold">Comment By :</div>
          <div className="text-gray-800">{comments?.commentedBy}</div>
        </div>

        <div className="flex mb-2 gap-2 ">
          <div className="font-semibold">Date & Time :</div>
          <div className="text-gray-800">
            {new Date(
              comments?.commentCreatedTime._seconds * 1000
            ).toLocaleString()}
          </div>
        </div>
      </div>
    ))
  ) : (
    <h2 className="text-center text-red-500 text-lg">
      No comments are available
    </h2>
  )}
</div>
      
    </>
  )
}

export default DailyUpdateCommentCard
